import React from "react";
import {
  type ConstructionTableHeaderCellProps,
  type ConstructionTableHeaderProps,
  exceptionCells,
} from "./ConstructionTableProps";
import IsaacTranslatedText from "../../../../components/isaacTranslatedText/IsaacTranslatedText";

const ConstructionTableHeader: React.FC<ConstructionTableHeaderProps> = ({
  constructionElementsName,
  constructionElementPropertyHeaders,
}) => {
  return (
    <thead>
      <tr>
        {constructionElementPropertyHeaders.map((constructionElementPropertyHeader, i) => {
          return (
            <ConstructionTableHeaderCell
              constructionElementsName={constructionElementsName}
              constructionElementPropertyHeader={constructionElementPropertyHeader}
              key={i}
            />
          );
        })}
      </tr>
    </thead>
  );
};

const displayHeaderForIsaacToggleButton = (
  constructionElementsName: string,
  constructionElementPropertyHeader: string,
): boolean => {
  if (
    constructionElementPropertyHeader === "isSelected" &&
    (constructionElementsName === "beams" ||
      constructionElementsName === "supportArms" ||
      constructionElementsName === "catenaries" ||
      constructionElementsName === "wires" ||
      constructionElementsName === "crossSpanWires" ||
      constructionElementsName === "hingedCantilevers" ||
      constructionElementsName === "devices")
  ) {
    return true;
  } else {
    return false;
  }
};

const ConstructionTableHeaderCell: React.FC<ConstructionTableHeaderCellProps> = ({
  constructionElementsName,
  constructionElementPropertyHeader,
}) => {
  if (displayHeaderForIsaacToggleButton(constructionElementsName, constructionElementPropertyHeader)) {
    return (
      <th>
        <IsaacTranslatedText parent={constructionElementsName} value={constructionElementPropertyHeader} />
      </th>
    );
  }

  if (exceptionCells.includes(constructionElementPropertyHeader)) {
    return null;
  }

  return (
    <th>
      <IsaacTranslatedText parent={constructionElementsName} value={constructionElementPropertyHeader} />
    </th>
  );
};

export default ConstructionTableHeader;
